
import { CustomerStatus } from '@/lib/supabase/customers/types/CustomerTypes';
import { useState, useEffect, useCallback } from 'react';

export const useCustomerFilter = () => {
  // Initialiser l'état depuis localStorage si disponible
  const [status, setStatus] = useState<CustomerStatus>(() => {
    const savedStatus = localStorage.getItem('customer-filter-status');
    return (savedStatus as CustomerStatus) || 'all';
  });
  
  // Fonction pour mettre à jour le statut avec persistance
  const updateStatus = useCallback((newStatus: CustomerStatus) => {
    setStatus(newStatus);
    localStorage.setItem('customer-filter-status', newStatus);
  }, []);
  
  return {
    status,
    setStatus: updateStatus
  };
};

// Pour la compatibilité
export type { CustomerStatus };
